import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

export interface AddPartOptionNoteInput {
    selectedOptionId: string;
    note: string;
    removeListPriceAdjustment: boolean;
    modifiedListPrice?: number;
    /** Used to invalidate the activity drawer; stripped before POST. */
    orderId?: string;
}

const addPartOptionNote = async (sessionId: string, input: AddPartOptionNoteInput): Promise<void> => {
    const { orderId: _orderId, ...body } = input;
    await axios.post(`${API_URL}/order/part/note`,
        body,
        {
            headers: {
                Authorization: sessionId
            }
        }
    );
};

export const useAddPartOptionNote = () => {
    const sessionContext = useContext(SessionContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: AddPartOptionNoteInput) => addPartOptionNote(sessionContext?.sessionId ?? '', input),
        onSuccess: (_, { orderId }) => {
            queryClient.invalidateQueries({
                queryKey: ['order-confirmation']
            });
            queryClient.invalidateQueries({
                queryKey: ['/order/detail']
            });
            queryClient.invalidateQueries({
                queryKey: ['/order/part']
            });
            if (orderId) {
                queryClient.invalidateQueries({
                    queryKey: ['/order/activity-logs', orderId]
                });
            } else {
                queryClient.invalidateQueries({
                    queryKey: ['/order/activity-logs']
                });
            }
        }
    });
};
